var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5179_20170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.946 8.30453C19.946 8.30453 20.5616 18.1209 10.7128 20.2916C10.1836 11.1231 17.959 8.61771 19.946 8.30453Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7.2894C20 7.10582 20 6.93303 19.9784 6.74945L19.6328 3.08854C19.46 1.22029 17.797 -0.162 15.9179 0.0215858L3.08853 1.23109C1.20948 1.40387 -0.162006 3.06694 0.0107801 4.93519L1.22028 17.7646C1.39307 19.6328 3.05614 21.0151 4.93519 20.8315L8.59609 20.4859C8.99566 20.4535 9.38443 20.3888 9.7624 20.3132C9.68681 19.6652 9.65441 19.0065 9.68681 18.3369C9.98918 12.5486 14.4276 7.96975 19.9892 7.2786L20 7.2894ZM4.07126 7.46219C4.11445 6.59826 4.85959 5.92871 5.72352 5.97191C6.58745 6.01511 7.257 6.76025 7.2138 7.62418C7.17061 8.48811 6.42547 9.15765 5.56154 9.11446C4.69761 9.07126 4.02806 8.32612 4.07126 7.46219ZM9.06046 16.1339C9.06046 16.1339 6.15549 15.8963 5.29156 12.2354C5.29156 12.2462 5.31316 12.2678 5.33475 12.2894C5.31316 12.2462 5.28076 12.203 5.28076 12.149C5.28076 12.041 5.31316 11.9438 5.37795 11.8574C5.47514 11.717 5.62633 11.6199 5.79912 11.6091C5.9827 11.6091 6.13389 11.7063 6.23108 11.8358C6.25268 11.8898 6.28508 11.9546 6.30668 12.0194C6.91143 13.5313 7.35419 14.6004 9.20084 15.0972C9.41683 15.1728 9.56802 15.3564 9.57881 15.5939C9.57881 15.8855 9.35203 16.1231 9.06046 16.1231V16.1339ZM12.2354 6.31748C12.2786 5.45355 13.0237 4.784 13.8877 4.8272C14.7516 4.8704 15.4211 5.61554 15.3779 6.47947C15.3348 7.3434 14.5896 8.01295 13.7257 7.96975C12.8618 7.92655 12.1922 7.18141 12.2354 6.31748Z",
    fill: "#9A9A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5179_20170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.8531,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickerIcon);
export default __webpack_public_path__ + "static/media/tickerIcon.8fa9ce53216902f45196b24901d07b0b.svg";
export { ForwardRef as ReactComponent };